import React from 'react'

const formatDate = (value) => new Date(value).toLocaleDateString('en-GB', {
  weekday: 'short',
  day: 'numeric',
  month: 'short'
})

// One card standing in for a series such as Guitar Lessons, linking to the
// group page that lists every session.
const GroupCard = ({ group }) => {
  const imageUrl = group.image_urls?.standard || group.image_urls?.hd
  const count = group.upcoming_count || 0

  return (
    <a
      href={group.url || `/groups/${group.slug}`}
      className="block group bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow hover:shadow-lg transition-all duration-200 hover:-translate-y-1"
    >
      <div className="relative aspect-[4/3]">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={group.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
            <svg
              className="w-16 h-16 text-gray-400 dark:text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}
        <div className="absolute bottom-2 right-2 bg-gray-900/80 dark:bg-black/80 text-white text-xs font-semibold px-2 py-1 rounded">
          {count} upcoming {count === 1 ? 'session' : 'sessions'}
        </div>
      </div>

      <div className="p-3 sm:p-4">
        {group.category && (
          <div className="flex flex-wrap gap-1 mb-2">
            <span className={`text-xs px-2 py-0.5 rounded text-white ${group.category_colors?.[0] || 'bg-gray-500'}`}>
              {group.category.toLowerCase()}
            </span>
          </div>
        )}

        <h3 className="font-serif text-base sm:text-lg text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 mb-2 line-clamp-2">
          {group.name}
        </h3>

        {group.next_start_time && (
          <div className="text-sm text-gray-600 dark:text-gray-400">
            Next: {formatDate(group.next_start_time)}
          </div>
        )}
      </div>
    </a>
  )
}

export default GroupCard
